<template>
  <v-container fluid class="request-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Request</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 3" step="3">File</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Request</p>
                        <v-select
                          class="mb-4"
                          :items=requesttype
                          v-model="request.requesttype"
                          v-bind:error="errorindex == 0"
                          v-on:change="clearFields(); clearTransactions()"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the request type">
                        </v-select>
                        <v-menu
                          ref="menu_requestdate"
                          v-model="menu_requestdate"
                          :close-on-content-click="false"
                          :return-value.sync="request.requestdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="request.requestdate"
                              label="Request Date"
                              v-bind="attrs"
                              v-bind:value="request.requestdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the request date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="request.requestdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_requestdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_requestdate.save(request.requestdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="employees.filter(employee=>employee.employeestatus=='Active').map(x => {
                            return {text: x.employeename, value: x._id};
                            })"
                          v-model="request.employeeid"
                          v-bind:error="errorindex == 2"
                          v-on:change="populateEmployeeFields"
                          outlined
                          dense
                          placeholder="Employee"
                          persistent-hint
                          single-line hint="Please choose the employee">
                        </v-select>                        
                        <v-text-field
                          class="mb-4"
                          v-model="request.requestname"
                          outlined
                          dense
                          placeholder="Employee Name"
                          persistent-hint
                          single-line hint="Enter the Employee Name">
                        </v-text-field>
                        <v-textarea
                          v-model="request.requestaddress"
                          outlined
                          rows=2
                          label="Address"
                          hint="please enter the employee address"
                        ></v-textarea>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="request.requestphone"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the phone">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="request.requestmobile"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line hint="Enter the mobile phone">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="request.requestnote"
                          outlined
                          dense
                          placeholder="Note"
                          persistent-hint
                          single-line hint="Enter the note">
                        </v-text-field>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/request/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center" v-if="request.requesttype=='Benefit Request'">
                    <v-col lg="12" md="12" sm="12"><p class="text-h5">Items</p></v-col>
                    <v-col cols="12" sm="12" md="3" lg="3">
                      <v-select
                        class="mb-4"
                        :items="getAccounts(request.requesttype)"
                        v-model="accountid"
                        v-bind:error="errorindex == 11"
                        outlined
                        dense
                        placeholder="Account"
                        persistent-hint
                        single-line hint="Account">
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" lg="3">
                      <v-text-field
                        v-model="transdesc"
                        class="mb-4"
                        outlined
                        dense
                        placeholder="Desc"
                        persistent-hint
                        single-line hint="Description">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2">
                      <v-text-field
                        v-model="transamount"
                        v-bind:error="errorindex == 12"
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        placeholder="Amt"
                        persistent-hint
                        single-line hint="Amount">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1">
                      <v-btn
                        block
                        class="button-shadow"
                        color="success"
                        @click="addTransaction()">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center" v-if="request.requesttype=='Benefit Request'">
                      <v-col cols="12" lg="12" md="12" sm="12">
                        <v-data-table
                          :headers="itemHeaders1"
                          :items="transactions"
                          :items-per-page="100"
                          class="elevation-0"
                        >
                          <template v-slot:item.accountid="{ item }">
                            {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn icon color="primary" @click="deleteTransaction(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                  </v-row>
                  <v-row justify="center" v-if="request.requesttype=='Leave Request' || request.requesttype=='Flexible Work Request'">
                    <v-col lg="12" md="12" sm="12"><p class="text-h5">Items</p></v-col>
                    <v-col cols="12" sm="12" md="3" lg="2">
                      <v-select
                        class="mb-4"
                        :items="getAccounts(request.requesttype)"
                        v-model="accountid"
                        v-on:change="clearDates"
                        v-bind:error="errorindex == 21"
                        outlined
                        dense
                        placeholder="Account"
                        persistent-hint
                        single-line hint="Account">
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" lg="2">
                      <v-menu
                          ref="menu_transstartdate"
                          v-model="menu_transstartdate"
                          :close-on-content-click="false"
                          :return-value.sync="transstartdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="transstartdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="transstartdate"
                              v-bind:error="errorindex == 22"
                              v-on="on"
                              persistent-hint
                              single-line 
                              hint="Start Date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="transstartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_transstartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_transstartdate.save(transstartdate); calculateEnddate();"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col  cols="12" sm="12" md="3" lg="2">
                      <v-text-field
                        v-model="transdays"
                        v-bind:error="errorindex == 23"
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        placeholder="Days"
                        clearable
                        v-on:input="calculateDays"
                        persistent-hint
                        single-line hint="Days">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="1" v-show="transdays==0.1 || transdays==0.2 || transdays==0.5">
                      <v-select
                        class="mb-4"
                        :items="['Am', 'Pm']"
                        v-model="transinfo"
                        outlined
                        dense
                        placeholder="Am/Pm"
                        persistent-hint
                        single-line hint="Am/Pm">
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" lg="2">
                      <v-text-field
                        outlined
                        dense
                        readonly
                        v-model="transenddate"
                        label="End Date"
                        v-bind:value="transenddate"
                        v-bind:error="errorindex == 1"
                        persistent-hint
                        single-line hint="End Date">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" lg="2">
                      <v-text-field
                        v-model="transdesc"
                        class="mb-4"
                        outlined
                        dense
                        placeholder="Desc"
                        persistent-hint
                        single-line hint="Description">
                      </v-text-field>
                    </v-col>
                    <v-col  cols="12" sm="12" md="1" lg="1">
                      <v-btn
                        block
                        class="button-shadow"
                        color="success"
                        @click="addTransaction()">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center" v-if="request.requesttype=='Leave Request' || request.requesttype=='Flexible Work Request'">
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-data-table
                          :headers="itemHeaders2"
                          :items="transactions"
                          :items-per-page="100"
                          class="elevation-0"
                        >
                          <template v-slot:item.accountid="{ item }">
                            {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                          </template>
                          <template v-slot:item.transdays="{ item }">
                            {{ item.transdays }} {{ item.transinfo!=null ? '(' + item.transinfo + ')' : '' }}
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn icon color="primary" @click="deleteTransaction(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError4">
                            Next
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Optional File</p>
                        <p>File:</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept=".pdf,.jpg" />
                        <v-img contain max-height="150" max-width="250" :src="fileurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 2"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertRequest()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import { isDateWeekend, dateDifference } from '@/mixins/date';
import router from '@/Routes';

export default {
  data () {
    return {
      itemHeaders1: [
        { text: 'Account', value: 'accountid' },
        { text: 'Description', value: 'transdesc', width: '30%'},
        { text: 'Amount', value: 'transamount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      itemHeaders2: [
        { text: 'Account', value: 'accountid' },
        { text: 'Start Date', value: 'transstartdate', width: '15%'},
        { text: 'End Date', value: 'transenddate', width: '15%'},
        { text: 'Num Days', value: 'transdays', width: '15%'},
        { text: 'Description', value: 'transdesc', width: '20%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      transactions: [],
      accountid: null,
      transtype: null,
      transsubtype: null,
      transstartdate: null,
      transenddate: null,
      transdesc: null,
      transamount: null,
      transdays: null,
      transinfo: null,
      menu_transstartdate: null,
      menu_transenddate: null,
      menu_requestdate: false,

      fileurl: undefined,
      filedata: undefined,
      filename: undefined,
      step: 1,
      request: {requestsubtotal: 0, requesttotal: 0, requestdays: 0},
      
      requesttype: ['Benefit Request','Leave Request', 'Flexible Work Request'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      weekend: {},
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
    ...mapState('Request', ['isReceiving'])
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Employee', ['getEmployeesRequest']),
    ...mapActions('Holiday', ['isDateHoliday']),
    ...mapActions('Request', ['getRequests', 'insertRequestRequest', 'insertRequestWithFileRequest']),
    ...mapActions('SystemSetting', ['getSetting', 'getWeekendSetting']),
    isDateWeekend,
    clearDates(){
      this.transenddate = null;
      this.transdays = null;
    },
    checkError(){
      if(!this.request.requesttype){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.request.requestdate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(dateDifference(Date(), this.request.requestdate)<-30){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.request.employeeid){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkError2(){
      if(!this.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.transamount){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    checkError3(){
      if(!this.accountid){
        this.haserrors = true;
        this.errorindex = 21;
        return false;
      }
      if(!this.transstartdate){
        this.haserrors = true;
        this.errorindex = 22;
        return false;
      }
      if(dateDifference(this.request.requestdate, this.transstartdate)<0){
        this.haserrors = true;
        this.errorindex = 22;
        return false;
      }
      if(!this.transdays){
        this.haserrors = true;
        this.errorindex = 23;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    checkError4(){
      if(this.transactions.length==0){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      this.step = 3;
      return true;
    },
    getAccounts(type){
      if(type=='Benefit Request'){
        return this.accounts.filter(x=>x.accountsubclass=='Flexible Savings' && x.accounttype=='Debit').map(x => {return {text: x.accountname, value: x._id};});
      }
      else if (type=='Leave Request'){
        return this.accounts.filter(x=>x.accountsubclass=='Employee Benefit').map(x => {return {text: x.accountname, value: x._id};});
      }
      else if (type=='Flexible Work Request'){
        return this.accounts.filter(x=>x.accountsubclass=='Flexible Work').map(x => {return {text: x.accountname, value: x._id};});
      }

    },
    showType(){
      let account = this.accounts.find(account=>account._id==this.accountid);
      if(account){
        if(account.accountname=='Annual Leave') return true;
        if(account.accountname=='Childcare Leave') return true;
      }
      return false;
    },
    populateEmployeeFields(employeeid){
      var employee = this.employees.find(employee=>employee._id == employeeid);
      this.request.employeeid = employee._id;
      this.request.requestname = employee.employeename;
      this.request.requestaddress = employee.employeeaddress;
      this.request.requestphone = employee.employeephone;
      this.request.requestmobile = employee.employeemobile;
    },
    calculateDays(){
      if(this.accountid==null) return;
      let account = this.accounts.find(account=>account._id==this.accountid);
      let value;
      if(account.accountname=='Medical Appointment'){
        if(this.transdays==null) value=null;
        else if(this.transdays<1) value=0.1;
        else if(this.transdays==0.5) value=0.1;
        else if(this.transdays==1) value=0.2;
        else if(this.transdays>1) value=0.2;
      }
      else{
        if(this.transdays==null) value=null;
        else if(this.transdays<1) value=0.5;
        else if(this.transdays>=1) value=parseInt(this.transdays);
      }
      this.$nextTick(() => {
        this.transdays = value;
        this.calculateEnddate();
      });   
      
      return value;
    },
    calculateEnddate(){
      if(this.transstartdate==null || this.transstartdate=='') return;
      if(this.transdays==null) return;
      console.log(this.transdays);
      if(this.transdays==0.1 || this.transdays==0.2 || this.transdays==0.5) this.transenddate = this.transstartdate;
      else this.transenddate = this.addDays(this.transstartdate, (this.transdays-1));
      if(this.transdays!=0.1 && this.transdays!=0.2 && this.transdays!=0.5) this.transinfo = null;
      this.adjustHoliday();
    },

    async adjustHoliday(){
      let d1 = new Date(Date.parse(this.transstartdate));
      let d2 = new Date(Date.parse(this.transenddate));
      let adjustment = 0;

      var index = d1;
      while(index <= d2){
        let isHoliday = await this.isDateHoliday(index);

        if(isDateWeekend(index, this.weekend)) adjustment++; 
        else if(isHoliday) adjustment++;        
        index = this.addDate(index, 1);
      }

      if(adjustment>0) this.transenddate = this.addDays(this.transenddate, adjustment);

      let d3 = new Date(Date.parse(this.transenddate));
      let isHoliday = await this.isDateHoliday(d3);
      while(isDateWeekend(d3, this.weekend) || isHoliday){
        this.transenddate = this.addDays(this.transenddate, 1);
        d3 = new Date(Date.parse(this.transenddate));
        isHoliday = await this.isDateHoliday(d3);
      }
    },
    calculateTotal(){
      if(this.request.requesttype=='Benefit Request'){
        this.request.requestsubtotal = this.transactions.reduce((item, obj) => item + parseFloat(obj.transamount), 0);
        this.request.requesttotal = this.request.requestsubtotal;
      }
      else if(this.request.requesttype=='Leave Request' || this.request.requesttype=='Flexible Work Request'){
        this.request.requestdays = this.transactions.reduce((item, obj) => item + parseFloat(obj.transdays), 0);
      }

    },
    addDate(date, days){
      let ms = date.getTime() + (1000 * 60 * 60 * 24 * (days));
      var result = new Date(ms);
      return result;
    },
    addDays(date, days) {
      let d1 = new Date(Date.parse(date));
      let d2 = this.addDate(d1, days);
      let month = d2.getMonth() < 9? "0" + (d2.getMonth() + 1).toString(): (d2.getMonth() + 1).toString();
      let day = d2.getDate() < 10 ? "0" + d2.getDate().toString() : d2.getDate().toString(); 
      let result = d2.getFullYear() + "-" + month + "-" + day;
      return result;
    },


    addTransaction(){
      if(this.request.requesttype=='Benefit Request'){
        if(!this.checkError2()) return;
      }
      else if(this.request.requesttype=='Leave Request' || this.request.requesttype=='Flexible Work Request'){
        if(!this.checkError3()) return;
      }
      
      this.insertTransaction();
      console.log(this.transactions);
      this.calculateTotal();
      this.clearFields();
    },
    insertTransaction(){
      if(this.request.requesttype=='Benefit Request'){
        this.transactions.push({
          id: Math.floor(Math.random() * Math.pow(10, 10)),
          employeeid: this.request.employeeid,
          accountid: this.accountid,
          transdesc: this.transdesc,
          transamount: this.transamount,
        });
      }
      else if(this.request.requesttype=='Leave Request' || this.request.requesttype=='Flexible Work Request'){
        this.transactions.push({
          id: Math.floor(Math.random() * Math.pow(10, 10)),
          employeeid: this.request.employeeid,
          accountid: this.accountid,
          transdesc: this.transdesc,
          transdays: this.transdays,
          transinfo: this.transinfo,
          transstartdate: this.transstartdate,
          transenddate: this.transenddate,
        });
      }

    },
    onFileChange(file) {
      if (!file) {return;}
      this.filedata = file;
      this.filename = file.name;
    },
    deleteTransaction(item){
      let index = this.findTransactionIndexById(item.id);
      this.transactions.splice(index,1);
      this.calculateTotal();
    },
    clearFields(){
      this.accountid = undefined;
      this.transdesc = undefined;   
      this.transamount = undefined;
      this.transstartdate = null;
      this.transenddate = null;
      this.transdays = null;
    },
    clearTransactions(){
      this.transactions = [];
    },
    findTransactionIndexById(id){
      let index;
      if(this.transactions.find(tran=>tran.id==id)==null) {return -1}
      for(index=0; index<this.transactions.length; index++){
        if(this.transactions[index].id==id){break;}
      }
      return index;
    },
    async insertRequest() {
      let json = {
        request: this.request,
        transactions: this.transactions,
        filedata: this.filedata,
        filename: this.filename,
      }
      console.log(json);
      if(this.filedata) await this.insertRequestWithFileRequest(json);
      else await this.insertRequestRequest(json);
      router.push('/request/list');
    },
  },
  async created () {
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.employees.length==0) await this.getEmployeesRequest();
    this.weekend = await this.getWeekendSetting({code: 'WorkplaceSettings', name: 'isSundayHoliday'});
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
